// Colors
export const primaryColor: string = "#111";
export const accentColor: string = "#ADF0E5";
export const backgroundColor: string = "#f4f4f4";
export const secondaryFontColor: string = "#7D879C";
export const borderColor: string = "#ddd";
export const placeholderColor: string = "#888888";
export const textBlue = "#3721ff";
export const backgroundBlue = "#a8acff";
export const backgroundGreen = "#E7FDD8";
export const textGreen = "#66BF3C";
export const backgroundOrange = "#FDEFC0";
export const textOrange = "#e0ac00";
export const backgroundRed = "#FFB9A8";
export const textRed = "#FF3100";
export const white = "#fff";

// Font Sizes
export const fontSizeXSmall = "12px";
export const fontSizeSmall = "14px";
export const fontSizeMedium = "16px";
export const fontSizeLarge = "18px";


// Layout
export const containerMaxWidth: string = "1400px";
